import {
  Avatar,
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Stack,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { stringAvatar } from "../../utils/helpers";
import HeaderText from "../../common/HeaderText";
import { useSelector } from "react-redux";
import { LogoutIcon, UserTagIcon } from "../../assets/constants";
import styled from "@emotion/styled";
import {
  resetAgentInvite,
  resetAgentsList,
  resetUnpaginatedAgentsList,
  resetUpdateAgentProfile,
} from "../../actions/Agency";
import { useDispatch } from "react-redux";
import {
  openTimeModal,
  resetAllBodyParts,
  resetAllNotifications,
  resetReviewedPatientsFunc,
  resetTimerItemsFunc,
  resetUnreviewedPatientsFunc,
  resetUserFeedNotifications,
  setEndTime,
  setGoBackFunc,
  setIsStopped,
  setLogoutClickedFunc,
  setNavigateItemFunc,
  setShowReviewedScreenFunc,
} from "../../actions/AppConfig";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import {
  resetCreateTimeEntry,
  resetGetTimeEntry,
} from "../../actions/TimeEntry";
import {
  resetAllPatients,
  resetUnpaginatedPatients,
} from "../../actions/Patients";
import { resetGetBillingSubscription } from "../../actions/BillingSubscription";
import { resetStepCounts } from "../../actions/StepsCountActions";
import { logout } from "../../actions/Auth";
import UserCard from "../UserCard";

const StyledMenuItem = styled(MenuItem)(() => ({
  padding: "16px !important",
}));

const UserProfileBox = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const buttonRef = useRef();

  const agentProfile = useSelector((state) => state.agentProfile);
  const { agentUser } = agentProfile;

  const timerModal = useSelector((state) => state.timerModal);
  const { isRunning, isPaused } = timerModal;

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const openStopTimeModalHandler = () => {
    dispatch(setIsStopped(false));
    dispatch(setGoBackFunc(false));
    // if (!isPaused) {
    //   dispatch(setIsRunning(false));
    //   dispatch(setPauseStartTime(Date.now()));
    //   dispatch(setPausedTime(0));
    // }
    dispatch(setEndTime(dayjs()));
    dispatch(openTimeModal());
    // setSelectValue("chat_communication");
  };

  const navigateProfileHandler = () => {
    dispatch(resetUpdateAgentProfile());
    if (!isRunning && !isPaused) {
      setAnchorEl(null);
      navigate("/profile");
    } else {
      dispatch(setNavigateItemFunc("/profile"));
      openStopTimeModalHandler();
    }
  };

  const handleClose = () => {
    if (buttonRef.current) {
      buttonRef.current.focus();
    }
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const logoutHandler = () => {
    dispatch(setLogoutClickedFunc(true));

    if (!isRunning && !isPaused) {
      setAnchorEl(null);
      dispatch(resetUnreviewedPatientsFunc());
      dispatch(resetReviewedPatientsFunc());
      dispatch(resetCreateTimeEntry());
      dispatch(resetUserFeedNotifications());
      dispatch(resetAllNotifications());
      dispatch(resetAllPatients());
      dispatch(resetAllBodyParts());
      dispatch(resetUnpaginatedPatients());
      dispatch(resetAgentsList());
      dispatch(resetUnpaginatedAgentsList());
      dispatch(resetGetBillingSubscription());
      dispatch(resetStepCounts());
      dispatch(resetTimerItemsFunc());
      dispatch(resetGetTimeEntry());
      dispatch(resetAgentInvite());
      dispatch(logout());
      dispatch(setShowReviewedScreenFunc(false));
      navigate("/");
    } else {
      openStopTimeModalHandler();
    }
  };

  return (
    <>
      <Stack sx={{ cursor: "pointer", overflow: "hidden" }}>
        <Box onClick={handleClick} ref={buttonRef}>
          <UserCard agentUser={agentUser} />
        </Box>
      </Stack>
      <Menu
        disableRestoreFocus
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            left: "0 !important",
            width: "252px",
            overflow: "visible",
            borderRadius: "8px",
            mt: "-2px",
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              //   ml: -0.5,
              //   mr: 1,
            },
          },
        }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        transformOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleClose}>
          <UserCard agentUser={agentUser} />
        </MenuItem>

        <Divider />
        {/* <StyledMenuItem onClick={navigateBillingHandler}>
                <ListItemIcon sx={{ marginRight: "10px" }}>
                  <BillingIcon fontSize="small" />
                </ListItemIcon>
                Billing{" "}
              </StyledMenuItem> */}
        <StyledMenuItem onClick={navigateProfileHandler}>
          <ListItemIcon sx={{ marginRight: "10px" }}>
            <UserTagIcon fontSize="small" />
          </ListItemIcon>
          User Account
        </StyledMenuItem>
        <StyledMenuItem onClick={logoutHandler}>
          <ListItemIcon sx={{ marginRight: "10px" }}>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          Logout
        </StyledMenuItem>
      </Menu>
    </>
  );
};

export default UserProfileBox;
